/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Tag = [
  "svg",
  defaultAttributes,
  [
    [
      "path",
      { d: "M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" }
    ],
    ["path", { d: "M7 7h.01" }]
  ]
];

export { Tag as default };
//# sourceMappingURL=tag.js.map
